import { render, staticRenderFns } from "./routeManage.vue?vue&type=template&id=6c89f290"
import script from "./routeManage.vue?vue&type=script&lang=js"
export * from "./routeManage.vue?vue&type=script&lang=js"
import style0 from "./routeManage.vue?vue&type=style&index=0&id=6c89f290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports